// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "b0bdeb0ba8c78c2cd8e5" + ".js";
};